import { Component, OnInit } from '@angular/core';
import * as dayjs from 'dayjs';
import { CommonService } from 'src/app/service/common.service';

import { DateTime } from "luxon";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {


  loading = false;
  constructor(public cm:CommonService) { 

    this.cm.getMessage().subscribe((massage)=>{
      if(massage.command == 'menu2'){
        this.clickMenu();
      }
    })

  }

  ngOnInit() {
    this.loading = true;
    this.getProjectDataFormFirebase();
    this.getDataStationInProject();
    this.getDataRoomInProject();
    this.getDataMemberInProject();
    this.getDataPowerGraph('day');
  }

  isShowMenu = true;
  clickMenu(){
    this.isShowMenu = !this.isShowMenu;
    this.cm.sendMessage('menu',String(this.isShowMenu));
  }

  type = 'line';
  data = {
    labels: this.genTestDay(),
    datasets: [
      {
        label: "Power Usage",
        data: this.genTestPower(),

        fill: true,
        pointRadius: 3,
        borderWidth:2,
        pointHoverRadius: 3,
        pointBackgroundColor: '#0AB39C',
        backgroundColor:'#E9F5F5',
        lineTension: 0,
        borderColor:'#F1FBF9',
      }
    ],
    
   
  };
  options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [{
          display: true,
          ticks: {
              beginAtZero: true,  
              max: 50,
          }
      }]
  }
  };

  genTestDay(){
    var data = [];
    for(var i = 0;i < 30;i++){
      data[i] = dayjs(new Date()).add(i-30,'day').format('DD/MM/YY')
    }
    return data
  }

  genTestPower(){
    var data = [];
    for(var i = 0;i < 30;i++){
      data[i] = Math.floor((Math.random() * 100) + 60);
    }
    return data
  }


  project;
  profile;
  getProjectDataFormFirebase(){
    const project_uid = this.cm.getProfile().project_uid
    this.cm.db.collection('projects').doc(project_uid).get().toPromise().then((data)=>{
      this.project = data.data();
      this.cm.saveProject(this.project);
      this.loading = false;
    })
  }


  stations = [];
  getDataStationInProject(){
    const project_uid = this.cm.getProfile().project_uid
    this.cm.db.collection('stations', ref => ref.where('project_uid','==',project_uid)).valueChanges().subscribe((data)=>{
      this.stations = data;
      this.cm.save_station(data);
    });
  }

  rooms = [];
  bill_total = 0;
  getDataRoomInProject(){
    const project_uid = this.cm.getProfile().project_uid
    this.cm.db.collection('projects').doc(project_uid).collection('rooms').get().toPromise().then((data)=>{
      this.rooms = [];
      for(var i = 0; i < data.docs.length;i++){
        this.rooms.push(data.docs[i].data());
        this.bill_total =  this.bill_total + parseFloat(data.docs[i].data().total);
      }
      this.cm.saveRoom(this.rooms);
      
    })
  }

  cal_power_usage(){
    var cal = 0;
    for(var i = 0;i < this.stations.length;i++){
      if(this.stations[i].current.length != 3){
        cal = cal + (((this.stations[i].current * this.stations[i].voltage)/1000));
      } else if(this.stations[i].current.length == 3){
        for(var j = 0;j < 3;j++){
          cal = cal + (((this.stations[i].current[j] * this.stations[i].voltage[j])/1000));
        }
      }
     
    }
    return cal.toFixed(2);
  }


  members = [];
  getDataMemberInProject(){
    const project_uid = this.cm.getProfile().project_uid
    this.cm.db.collection('members', ref=>ref.where("project_uid","==",project_uid)).get().toPromise().then((data)=>{
      this.members = [];
      for(var i = 0; i < data.docs.length;i++){
        this.members.push(data.docs[i].data());
      }
      this.cm.saveMember(this.members);
      
    })
  }

  countMember(){
    var count = 0;
    for(var i = 0;i < this.rooms.length;i++){
      if(this.rooms[i].members){
        for(var j = 0;j < this.rooms[i].members.length;j++){
          if(this.rooms[i].members[j]){
            count = count + 1;
          }
         
        }
      }
      
    }
    return count;
  }

  checkOnlineStation(time){
    var time_now = Date.now();
    // var wait_sec = 240;
    var wait_sec = 240;
    if(time_now - time < (wait_sec * 1000)){
      return true;
    } else {
      return false;
    }
  }

  clickSelectTimeGraph(type_time){
    this.getDataPowerGraph(type_time);
  }

  database_power = [];
  start_time_show;
  stop_time_show;
  getDataPowerGraph(type_time){
    var start_time = 0;
    var stop_time  = 0;
    
    if(type_time == 'day'){
      start_time  = DateTime.local().startOf('day').toMillis();
      stop_time   = DateTime.local().endOf('day').toMillis();

      this.start_time_show = DateTime.local().startOf('day').toFormat('yyyy-MM-dd');
      this.stop_time_show = DateTime.local().endOf('day').toFormat('yyyy-MM-dd');
    } else if(type_time == 'week'){
      start_time  = DateTime.local().startOf('week').toMillis();
      stop_time   = DateTime.local().endOf('week').toMillis();

      this.start_time_show = DateTime.local().startOf('week').toFormat('yyyy-MM-dd');
      this.stop_time_show = DateTime.local().endOf('week').toFormat('yyyy-MM-dd');
    } else if(type_time == 'month'){
      start_time  = DateTime.local().startOf('month').toMillis();
      stop_time   = DateTime.local().endOf('month').toMillis();

      this.start_time_show = DateTime.local().startOf('month').toFormat('yyyy-MM-dd');
      this.stop_time_show = DateTime.local().endOf('month').toFormat('yyyy-MM-dd');
    } else if(type_time == 'range'){
      start_time  = DateTime.fromISO(this.start_time_show).startOf('day').toMillis();
      stop_time   = DateTime.fromISO(this.stop_time_show).endOf('day').toMillis();
    }
    if(stop_time > start_time){
      this.cm.db.collection('projects').doc(this.cm.getProfile().project_uid).collection('log_power',ref=>ref.where('create_time',">",start_time).where('create_time',"<",stop_time)).get().toPromise().then((data)=>{
        this.database_power = [];
        for(var i=0;i < data.docs.length;i++){
          this.database_power.push(data.docs[i].data());
        }
        this.genGraph();
      })
    }
    


  }




  genGraph(){
    var label_show  = [];
    var data_show   = [];
    var max_show    = 1;
    for(var i = 0;i<this.database_power.length;i++){
      label_show[i] = this.cm.showTimeFormat(this.database_power[i].create_time);
      data_show[i] = this.database_power[i].power / 1000;
      if(max_show <  data_show[i]){
        max_show = data_show[i];
      }
    }
    this.data = {
      labels: label_show,
      datasets: [
        {
          label: "Power Usage",
          data: data_show,
          fill: true,
          pointRadius: 3,
          borderWidth:2,
          pointHoverRadius: 3,
          pointBackgroundColor: '#0AB39C',
          backgroundColor:'#E9F5F5',
          lineTension: 0,
          borderColor:'#F1FBF9',
        }
      ],
    };

    this.options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
            display: true,
            ticks: {
                beginAtZero: true,  
                max: max_show * 2,
            }
        }]
    }
    };
  }

  count_station_online(){
    var c = 0;
    var p = 0;
    for(var i = 0;i < this.stations.length;i++){
      if(this.checkOnlineStation(this.stations[i].updateat)){
        c = c + 1;
      }
    }
    p = (c/this.stations.length) * 100;
    return p.toFixed(2);
  }


  count_station_charge_point(){
    var c = 0;
    for(var i = 0;i < this.stations.length;i++){
      if(this.stations[i].status == 2){
        c = c + 1;
      }
    }
    return c;
  }

  cal_power_station(station){
    var p = 0;
    if(station.current.length == 3){
      p = (station.current[0] * station.voltage[0]) + (station.current[1] * station.voltage[1]) + (station.current[2] * station.voltage[2]);
      p = (p / 1000); 
    } else {
      p = (station.current * station.voltage)
      p = (p/1000);
    }
    return p.toFixed(2);
  }



}
